import {getFetch, postFetch,postJsonFetch} from './httpConfig';


// 网站首页配置列表
// cms_wechat_qrcode 微信小程序二维码
// cms_website_logo 网站logo
// cms_website_title 网站标题
// cms_contactus_mobile 联系我们-电话
// cms_contactus_address 联系我们-地址
// cms_contactus_postcode 联系我们-邮编
// cms_copy_right 版权信息
export function getConfig(data) {
  return getFetch(`website/config/index`, data);
}
// 顶部banner
export function getBannerList(data) {
  return getFetch(`website/banner/top`, data);
}
// 滚动banner列表
export function getScrollList(data) {
  return getFetch(`website/banner/scrollList`, data);
}
// 对联广告列表
export function getCoupletList(data) {
  return getFetch(`website/ad/coupletList`, data);
}

// 飘窗广告列表
export function getFloatList(data) {
  return getFetch(`website/ad/floatList`, data);
}
// 栏目树表
export function getTreeList(data) {
  return getFetch(`website/category/treeList`, data);
}
// 文章列表
export function getNewList(data) {
  return getFetch(`website/article/list`, data);
}
// 文章详情
export function getNewDetail(data) {
  return getFetch(`website/article/detail`, data);
}
// 友情链接列表
export function getLinkList(data) {
  return getFetch(`website/link/list`, data);
}
// 快捷导航列表
export function getQuickNavList(data) {
  return getFetch(`website/quickNav/list`, data);
}
// 文章搜索
export function getArticleSearch(data) {
  return getFetch(`website/article/search`, data);
}
// 文章上下篇
export function getNextAndPrev(data) {
  return getFetch(`website/article/nextAndPrev`, data);
}

// 客户列表
export function getClientList(data) {
  return getFetch(`website/client/list`, data);
}
// 荣誉资质列表
export function getHonorList(data) {
  return getFetch(`website/honor/list`, data);
}

// 案例列表
export function getCaseList(data) {
  return getFetch(`website/case/list`, data);
}

// 解决方案列表
export function getSolutionList(data) {
  return getFetch(`website/solution/treeList`, data);
}
// 字典列表
export function getDictList(data) {
  return getFetch(`dict/getDictList`, data);
}
// 解决方案详情
export function getSolutionDetail(data) {
  return getFetch(`website/solution/form`, data);
}
// 案例详情
export function getCaseDetail(data) {
  return getFetch(`website/case/form`, data);
}
// 上下篇案例
export function getCaseNextAndPrev(data) {
  return getFetch(`website/case/nextAndPrev`, data);
}
// 案例解决方案列表
export function getCaseSolutionList(data) {
  return getFetch(`website/case/solutionList`, data);
}

// 招聘列表
export function getRecruitList(data) {
  return getFetch(`website/recruit/list`, data);
}
// 文章快速搜索
export function getArticleFastSearch(data) {
  return getFetch(`website/article/fast/search`, data);
}

// 资质荣誉详情
export function getHonorDetail(data) {
  return getFetch(`website/honor/form`, data);
}
// 知识产权列表
export function getPropertyList(data) {
  return getFetch(`website/property/list`, data);
}
// 知识产权详情
export function getPropertyDetail(data) {
  return getFetch(`website/property/form`, data);
}
// 关键词列表
export function getKeywordList(data) {
  return getFetch(`website/keyword/list`, data);
}
